/* ==========================================================================
   CheckboxToggle > Prototype
   ========================================================================== */

const checkboxToggle = {
    /* Display */
    show: function Fn() {
        this.element.classList.remove(this.config.css.hidden);

        return this;
    },

    /* Hidde */
    hide: function Fn() {
        this.element.classList.add(this.config.css.hidden);

        return this;
    },

    /* Has error */
    hasError: function Fn() {
        return this.error;
    },

    /* Set valid */
    setValid: function Fn() {
        this.element.classList.remove(this.config.css.error);
        this.element.classList.add(this.config.css.valid);

        /* Set validation to state */
        this.error = false;

        return this;
    },

    /* Set error */
    setError: function Fn() {
        this.element.classList.remove(this.config.css.valid);
        this.element.classList.add(this.config.css.error);

        /* Set error to state */
        this.error = true;

        return this;
    },

    /* Reset status */
    resetStatus: function Fn() {
        this.element.classList.remove(this.config.css.valid);
        this.element.classList.remove(this.config.css.error);

        /* Reset validation to state */
        this.error = false;

        return this;
    },

    /* Get input */
    getInput: function Fn() {
        return this.element.querySelector('input');
    },

    /* Get label */
    getLabel: function Fn() {
        return this.element.querySelector('label');
    },

    /* Pairing label */
    setPairing: function Fn() {
        if (this.element.querySelector('label')) {
            this.getInput().setAttribute('id', this.id);
            this.getLabel().setAttribute('for', this.id);
        }

        return this;
    },

    /* Status is checked */
    isChecked: function Fn() {
        return this.checkbox.isChecked();
    },

    /* Check */
    check: function Fn() {
        if (!this.isChecked()) this.checkbox.getInput().checked = true;

        return this;
    },

    /* Uncheck */
    uncheck: function Fn() {
        if (this.isChecked()) this.checkbox.getInput().checked = false;

        return this;
    },

    /* On change */
    onChange: function Fn(event = false) {
        /* Fire external callbacks */
        if (this.config.onChange.length > 0) this.config.onChange.forEach(item => item.call(this, this, event));

        return this;
    },

    /* Add event listener */
    addEventListener: function Fn() {
        /* Bind events */
        this.bindEvents();

        /* On change */
        this.checkbox.getInput().addEventListener('change', this.onChange);

        return this;
    },

    /* Remove event listener */
    removeEventListener: function Fn() {
        /* On change */
        this.checkbox.getInput().removeEventListener('change', this.onChange);

        return this;
    },

    /* Bind events */
    bindEvents: function Fn() {
        this.onChange = this.onChange.bind(this);

        return this;
    },

    /* Setup dom  */
    setupDom: function Fn() {
        /* Inner reference */
        const inner = this.element.querySelector('[data-inner]');

        /* Toggle reference */
        const toggle = this.element.querySelector('[data-toggle]');

        this.checkbox.getLabel().appendChild(inner);
        this.checkbox.getLabel().appendChild(toggle);
    },

    /* Init */
    init: function Fn() {
        /* Connect the label in case it has it with its input */
        this.setPairing();

        /* Adding listener */
        this.addEventListener();
    }
};

module.exports = checkboxToggle;
